
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trek/[slug]",
      function () {
        return require("private-next-pages/trek/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trek/[slug]"])
      });
    }
  